import { combineReducers } from 'redux'
import auth from './auth';
import app from './app';
import { reducer as form  } from 'redux-form';


export default combineReducers({
    auth,
    app,
    form
})



// WEBPACK FOOTER //
// ./src/reducers/index.js